import { LocaleType, LOCALES } from '@benzinga/translate';
import { KoreaConfig } from '../config/global/kr/config';
import { JapanConfig } from '../config/global/jp/config';
import { SpainConfig } from '../config/global/es/config';
import { ItalyConfig } from '../config/global/it/config';
import { FranceConfig } from '../config/global/fr/config';
import { IndiaConfig } from '../config/global/in/config';
import { DomainType, GlobalNavigationConfig, DOMAINS } from '../entities';

export const getGlobalConfigByLocale = (locale: LocaleType): GlobalNavigationConfig | null => {
  const configs: Partial<Record<LocaleType, GlobalNavigationConfig>> = {
    [LOCALES.KO]: KoreaConfig,
    [LOCALES.JA]: JapanConfig,
    [LOCALES.ES]: SpainConfig,
    [LOCALES.IT]: ItalyConfig,
    [LOCALES.FR]: FranceConfig,
  };

  return configs[locale] || null;
};

export const getGlobalConfigByDomain = (domain: DomainType): GlobalNavigationConfig | null => {
  const configs: Partial<Record<DomainType, GlobalNavigationConfig>> = {
    [DOMAINS.IN]: IndiaConfig,
  };

  return configs[domain] || null;
};

export const getGlobalConfig = (host: string, locale: LocaleType): GlobalNavigationConfig | null => {
  const domain = host?.split('.')?.[0] ?? 'www';

  if (Object.values(DOMAINS).includes(domain as DOMAINS)) {
    return getGlobalConfigByDomain(domain as DOMAINS);
  } else {
    return getGlobalConfigByLocale(locale);
  }
};
